import { observable } from "mobx";
import { ProgressStatus } from "../ViewModel";

export class WinningDataInner {
    @observable winningValue!: string;
    @observable winningStatus?: ProgressStatus;
    periodNumber!: number;
    @observable statusClass?: string;
}